// Part of every editor, and deliberately free of `@lexical/table`: this is how the static bundle
// asks for a table edit without importing the code that performs it. The handlers are registered
// by `TablesExtension`, which loads on demand; with no handler, a command is simply not handled.
import { createCommand, type LexicalCommand } from "lexical";
import type { TableEdit, TableRefusal } from "../../core/tables";

export type { TableEdit, TableRefusal };

/**
 * A command only answers "handled or not", so the reason for a refusal comes back through the
 * payload. Handled with `refused` still `null` means the edit was made.
 */
export interface TableOutcome {
  refused: TableRefusal | null;
}

export interface InsertTablePayload {
  rows: number;
  columns: number;
  headerRow: boolean;
  outcome: TableOutcome;
}

export interface EditTablePayload {
  edit: TableEdit;
  outcome: TableOutcome;
}

export const INSERT_TABLE_COMMAND: LexicalCommand<InsertTablePayload> =
  createCommand("z-editor/insert-table");

export const EDIT_TABLE_COMMAND: LexicalCommand<EditTablePayload> =
  createCommand("z-editor/edit-table");

/** What the slash menu and `run-command` make: small enough to fill in, a header row to start. */
export const DEFAULT_TABLE = { rows: 3, columns: 3, headerRow: true } as const;
